import React from "react";
import "../../components/DesignationList/DesignationList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const DesignationList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  setOpenAddProfile 

}) => {

  function HandleChange(param) {
    
    GetId(param);
  }
  
  return (
    <div className="container-fluid">
      <div className="designationList">
        <table>
          <tr className="designationListHeading">
            <th>S No.</th>
            <th>Designation ID</th>
            <th>Department Name</th>
            <th>Designation Name</th>
            <th>Action</th>
          </tr>
          {userDetailResponse !== null ? (
            userDetailResponse.map((user, index) => (
              <tr key={user.desg_id}>
                <td>{index + 1}</td>
                <td>{user.desg_id}</td>
                <td>{user.department}</td>
                <td>{user.designation}</td>
                <td>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}
                    onClick={() => {setOpenProfile(!openProfile); 
                      HandleChange(user.desg_id); 
                      setOpenAddProfile(false); }}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}
        </table>
      </div>
    </div>
  );
};

export default DesignationList;
